import { computed, observable, action } from 'mobx';
import createBrowserHistory from 'history/createBrowserHistory';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

import { inject, provideSingleton } from '../utils/decorators';
import { ApiStore } from './ApiStore';
import { IFreigabenResponse, IPersonallisteResponse, IProfileResponse } from '../models/ApiTypes';

/**
 * Store für globale UI Funktionen sowie Routing
 */
@provideSingleton(UiStore)
export class UiStore {

  history = syncHistoryWithStore(createBrowserHistory(), new RouterStore());
  @inject(ApiStore) apiStore: ApiStore;
  @observable userProfile?: IProfileResponse;
  @observable freigaben?: IFreigabenResponse;
  @observable personalliste?: IPersonallisteResponse;
  @observable benachrichtigung: string = '';

  @computed get isLoggedIn() {
    return (this.apiStore.token !== '');
  }

  @computed get userDisplayName() {
    return (this.userProfile) ? `${this.userProfile.vorname} ${this.userProfile.nachname}` : '';
  }

  async loadUserProfile() {
    const userProfile = await this.apiStore.profil();
    if (userProfile.ok) {
      this.setUserProfile(userProfile.json);
      // Benachrichtigung laden
      let benachrichtigung = await this.apiStore.benachrichtigung();
      if (benachrichtigung.ok) {
        this.setBenachrichtigung(benachrichtigung.json.text);
      }
    }
  }

  @action setUserProfile(userProfile: IProfileResponse) {
    this.userProfile = userProfile;
  }

  async loadFreigaben() {
    const freigaben = await this.apiStore.freigaben();
    if (freigaben.ok) {
      this.setFreigaben(freigaben.json);
    }
  }

  @action setFreigaben(freigaben: IFreigabenResponse) {
    this.freigaben = freigaben;
  }

  async loadPersonallisteKategorie(kategorie: string) {
    const personalliste = await this.apiStore.personallistekategorie(kategorie);
    if (personalliste.ok) {
      this.setPersonalliste(personalliste.json);
    }
  }

  @action setPersonalliste(personalliste: IPersonallisteResponse) {
    this.personalliste = personalliste;
  }

  @action clearUserProfile() {
    this.userProfile = undefined;
    this.benachrichtigung = '';
  }

  @action setBenachrichtigung(value: string) {
    this.benachrichtigung = value;
  }

  navigateTo(page: string, replace: boolean = false) {
    let toPage = (page[0] === '/') ? page : `${this.history.location.pathname}/${page}`;
    if (replace) {
      this.history.replace(toPage);
    } else {
      this.history.push(toPage);
    }
  }

  navigateBack() {
    this.history.goBack();
  }

  @computed get currentLocation() {
    return this.history.location;
  }

  async login(username: string, password: string) {
    const response = await this.apiStore.login(username, password);
    if (response.ok) {
      if (response.json.token) {
        this.apiStore.setToken(response.json.token);
      }
    }
    return response;
  }

  async logout() {
    await this.apiStore.logout();
    this.clearUserProfile();
    this.apiStore.deleteToken();
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/UiStore.ts